import React from 'react';
import c from 'classnames';
import { PapiNetworkbarStrip } from '@wix/da-papi-types';
import GlobalShopStatisticsBlock from './_partials/GlobalShopStatisticsBlock';
import DreamupBlock from './_partials/DreamupBlock';
import { useStrips } from './strips/useStrips';
import s from './ShopSellYourArtPage.scss';

interface Props {
  strips?: PapiNetworkbarStrip[];
}

const ShopSellYourArtPage: React.FC<Props> = ({ strips }) => {
  const renderedStrips = useStrips(
    strips,
    c(s['section-padding'], s['strip-background'])
  );

  return (
    <>
      {renderedStrips}
      <GlobalShopStatisticsBlock className={s['section-padding']} />
      <DreamupBlock className={s['section-padding']} />
    </>
  );
};

ShopSellYourArtPage.displayName = 'ShopSellYourArtPage';

export default ShopSellYourArtPage;
